import './Breadcrumbs.css';
import React from 'react';
import { withRouter } from 'react-router-dom';
import HeaderModuleWrapper from './HeaderModuleWrapper';
import IconChevronRight from '../atoms/Icons/IconChevronRight';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc } from '../../utils/tealium';
import { getDictionaryItem } from '../../utils';
const Breadcrumbs = _ref => {
  let {
    mobileLabel,
    location,
    breadcrumbAnalytics,
    dictionary,
    userProfile = {}
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const currentLocation = location && location.pathname ? location.pathname : undefined;
  const breadcrumb = sitecoreContext.breadcrumb;
  const breadcrumbsAccessibilityTitle = getDictionaryItem(dictionary && dictionary.commonDictionary, 'breadcrumbs') || 'Breadcrumbs';
  if (!breadcrumb || breadcrumb.length <= 1) {
    return null;
  }
  const previousLevelPage = breadcrumb.length >= 2 ? breadcrumb[breadcrumb.length - 2] : undefined;
  const previousLevelUrl = previousLevelPage && previousLevelPage.url ? previousLevelPage.url : '/';
  const previousLevelLabel = previousLevelPage && previousLevelPage.label ? previousLevelPage.label : mobileLabel;
  const breadcrumbCssClass = 'breadcrumb-nav';
  const replacePlaceholders = label => {
    if (label.indexOf('#username#') > -1) {
      const {
        firstName,
        lastName
      } = userProfile;
      return label.replace('#username#', `${firstName} ${lastName}`);
    }
    return label;
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: breadcrumbCssClass
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: `
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            ${breadcrumb.map((b, index) => {
        return `{
                  "@type": "ListItem",
                  "position": ${index + 1},
                  "name": "${b.label && b.label.replace(/"/g, "'")}",
                  "item": "${sitecoreContext && sitecoreContext.origin}${b.url}"
                }`;
      })}
          ]
        }`
    }
  }), /*#__PURE__*/React.createElement("ul", {
    className: "breadcrumb"
  }, /*#__PURE__*/React.createElement("li", {
    className: "accessibility-hidden-text"
  }, breadcrumbsAccessibilityTitle), breadcrumb.map((b, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: "breadcrumb__list"
  }, currentLocation && b.url.toLowerCase() === currentLocation.toLowerCase() ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: replacePlaceholders(b.label)
    }
  }) : /*#__PURE__*/React.createElement("a", {
    href: b.url,
    title: b.label,
    className: "link",
    onClick: () => {
      tealiumClickFunc(breadcrumbAnalytics, b.enLabel);
    }
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: b.label
    }
  })), index < breadcrumb.length - 1 && /*#__PURE__*/React.createElement(IconChevronRight, {
    className: "breadcrumb__list-icon"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "breadcrumb__back"
  }, /*#__PURE__*/React.createElement("a", {
    className: "breadcrumb__back-link",
    href: previousLevelUrl
  }, /*#__PURE__*/React.createElement(IconChevronRight, {
    rtl: rtl
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: previousLevelLabel
    }
  }))));
};
export default withRouter(Breadcrumbs);
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement(HeaderModuleWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
const commonStyles = "cuqupq4";
const ltrStyles = "l1o46kfz";
const rtlStyles = "roq3hbm";